import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC } from "react";

import { SettingsConfirmModal } from "../../../components/modal/SettingsConfirmModal";

type Props = {
  contactName: string;
  title?: string;
  description?: string;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const DELETE_CONTACT_DESCRIPTION =
  "Do you want to permanently delete this contact?<br />All associated work items, notes, files, payments, and invoices will also be deleted. This action cannot be undone.";

const getDeleteContactTitle = (contactName: string): string => {
  const trimmedContactName = contactName.trim();

  if (!trimmedContactName) {
    return "Delete Contact?";
  }

  return `Delete '${trimmedContactName}' Contact?`;
};

export const ContactDeleteConfirmModal: FC<Props> = ({
  contactName,
  title,
  description = DELETE_CONTACT_DESCRIPTION,
  isLoading,
  onClose,
  onConfirm,
}) => (
  <SettingsConfirmModal
    onClose={onClose}
    onConfirm={onConfirm}
    icon={<FontAwesomeIcon icon={faTrashCan} />}
    title={title || getDeleteContactTitle(contactName)}
    description={description}
    confirmText={"Delete"}
    variant={"danger"}
    isLoading={isLoading}
  />
);
